import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-blueland',
  templateUrl: './blueland.component.html',
  styleUrls: ['./blueland.component.scss']
})
export class BluelandComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['blueland'];
  }

}
